import useStoreLinks from "../../../common/features/store/useStoreLinks.ts";
import OnboardingBanner from "../common/onboarding-banner/OnboardingBanner.tsx";
import MiscellaneousStopwatch from "../../../common/icons/MiscellaneousStopwatch.tsx";
import { useIntl } from "react-intl";
import { UserPreferenceKey } from "../../../common/api/decimal/methods/user.ts";

export default function ExpiredOnboardingBanner() {
  const intl = useIntl();
  const { isVstStore, makeBasicStoreURL } = useStoreLinks();

  let bannerProps = {
    title: intl.formatMessage({ defaultMessage: "View Your Expired Titles" }),
    body: intl.formatMessage({
      defaultMessage: "All items that have expired will show up here.",
    }),
  };

  if (isVstStore) {
    bannerProps = {
      title: intl.formatMessage({
        defaultMessage: "Regain Access to Your Titles",
      }),
      body: intl.formatMessage({
        defaultMessage:
          "All items that have expired will show up here. Select ‘Get Access’ to view re-purchase options, or visit the Store to explore thousands of titles available for purchase.",
      }),
    };
  }

  return (
    <OnboardingBanner
      icon={<MiscellaneousStopwatch />}
      linkText={intl.formatMessage({ defaultMessage: "Visit Store" })}
      href={makeBasicStoreURL({
        utm_medium: "bookshelf-home-banner-expired",
      })}
      bannerSeenPreferenceKey={
        UserPreferenceKey.ExpiredOnboardingBannerDismissed
      }
      {...bannerProps}
    />
  );
}
